import { render, staticRenderFns } from "./OverviewStats.vue?vue&type=template&id=603949d2&scoped=true"
import script from "./OverviewStats.vue?vue&type=script&lang=js"
export * from "./OverviewStats.vue?vue&type=script&lang=js"
import style0 from "./OverviewStats.vue?vue&type=style&index=0&id=603949d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603949d2",
  null
  
)

export default component.exports